import { generateColourPalette } from "utils/colour"
import { DefaultWetstockDeliveryColours } from "utils/constants"

/**
 * Generates an array of hex code colours from a given hex code base colour specifically for the wetstock deliveries widget.
 * 
 * Returns a default colour palette if baseColour or numberOfDeliveries isn't defined.
 * 
 * @param {string} baseColour - The base colour to create the colour palette from.
 * @param {string} numberOfDeliveries - The number of deliveries to calculate how many colours are returned.
 */
const generatePaletteForDeliveries = (baseColour, numberOfDeliveries = 0) => {
    let palette = [] // This is the palette array we will return

    const paletteLightToDark = generateColourPalette(baseColour) // Generate custom palette using base colour as a starting point

    // Use default palette if paletteLightToDark or numberOfDeliveries is undefined
    if(!paletteLightToDark || !numberOfDeliveries) return DefaultWetstockDeliveryColours

    // Split paletteLightToDark into a lighterPalette and darkerPalette (the base colour will be part of the darker palette)
    const lighterPalette = paletteLightToDark.slice(0, paletteLightToDark.indexOf(baseColour));
    const darkerPalette = paletteLightToDark.slice(paletteLightToDark.indexOf(baseColour));

    // Loop through darkerPalette and lighterPalette to create an ordered palette for the given number of deliveries
    for (let i = 0; i < numberOfDeliveries; i++) {
        if(i <= (darkerPalette.length - 1)) {
            // Push colours from the darkerPalette into palette array first
            palette.push(darkerPalette[i])
        }
        else if(i > (darkerPalette.length - 1)) {
            // If lighterPalette contains colours, add the last colour in the lighterPalette to the start of the palette array
            if(lighterPalette.length < 1) break
            palette.unshift(lighterPalette.pop())
        }
    }

    // Calculate if we need to add black to our palette if the number of deliveries is greater than the amount of colours in the palette
    const paletteLengthMinusNumberOfDeliveries = paletteLightToDark.length - numberOfDeliveries
    if(paletteLengthMinusNumberOfDeliveries < 0) {
        const numberOfColoursToAddToPalette = Math.abs(paletteLengthMinusNumberOfDeliveries)

        for (let i = 0; i < numberOfColoursToAddToPalette; i++) {
            palette.push('#000000')
        }
    }

    return palette
}

export { generatePaletteForDeliveries }
